import Glide from "@glidejs/glide";

const magazineCardSliderHandler = () => {
	const magazineSliders = document.querySelectorAll(
		".magazine-card-row__glide",
	);

	magazineSliders.forEach((slider, i) => {
		// Check if the slider has already been initialized
		const activeBullet = "glide__bullet--active";
		const bulletsContainerElement = slider.querySelector(".bullets-desktop");
		const bulletsContainerElementTablet = slider.querySelector(".bullets-tablet");

		//Handle bullet classes - function used to update dots before slide animation.
		const changeActiveBullet = (newIndex, containerElement) => {
			const glideDir = containerElement.querySelector(`[data-glide-dir="=${newIndex}"]`);
		
			containerElement.querySelector(`.${activeBullet}`).classList.remove(activeBullet);
		
			if (glideDir) glideDir.classList.add(activeBullet);
		};
		
		if (!slider.hasAttribute("data-initialized")) {
			const glide = new Glide(slider, {
				type: "slider",
				perView: 4,
				perSwipe: "|",
				gap: 24,
				animationDuration: 1000,
				breakpoints: {
					1024: {
						perView: 2,
					},
					641: {
						type: "slider",
						perView: 1,
						peek: {
							before: 0,
							after: 100,
						},
						gap: 8,
					},
				},
			}).mount();
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");

			//run dots animation -desktop
			glide.on("run", () => {
				requestAnimationFrame(() => changeActiveBullet(glide.index, bulletsContainerElement));
			});

			//run dots animation - tablet
			glide.on("run", () => {
				requestAnimationFrame(() => changeActiveBullet(glide.index, bulletsContainerElementTablet));
			});
		}
	});
};

if (document.readyState !== "loading") {
	magazineCardSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", magazineCardSliderHandler);
}